import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-zinc-950 text-white">
      <div className="px-8 md:px-16 lg:px-24 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-4">
            <img
              src="https://public.readdy.ai/ai/img_res/856ce707-63c2-4323-8fd2-5d8634add062.png"
              alt="AxisPoint Medical"
              className="h-10 w-auto object-contain mb-6 brightness-0 invert"
            />
            <p className="text-zinc-500 text-sm leading-relaxed mb-8 max-w-xs">
              Compassionate, comprehensive primary care for every stage of life. Your health is our mission.
            </p>
            <div className="flex gap-3">
              {['ri-facebook-fill', 'ri-twitter-x-fill', 'ri-instagram-line', 'ri-linkedin-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-zinc-800 hover:border-rose-500 hover:text-rose-400 transition-all duration-200 cursor-pointer text-zinc-500"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-6">Navigate</h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'Our Services', path: '/services' },
                { label: 'Book Appointment', path: '/book-appointment' },
                { label: 'Patient Resources', path: '/patient-resources' },
                { label: 'Contact Us', path: '/contact' },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-zinc-400 text-sm hover:text-white transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-6">Services</h4>
            <ul className="space-y-3">
              {['Annual Wellness Exams', 'Chronic Disease Management', 'Preventive Care', 'Telehealth Visits', 'Pediatric Care', 'Senior Care'].map((s) => (
                <li key={s}><span className="text-zinc-400 text-sm">{s}</span></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-6">Contact</h4>
            <ul className="space-y-5">
              <li className="flex gap-3 items-start">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-rose-400 text-sm"></i>
                </div>
                <span className="text-zinc-400 text-sm leading-relaxed">4820 W Flamingo Rd, Suite 100<br />Las Vegas, NV 89103</span>
              </li>
              <li className="flex gap-3 items-center">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-line text-rose-400 text-sm"></i>
                </div>
                <a href="tel:+17025550192" className="text-zinc-400 text-sm hover:text-white cursor-pointer">(702) 555-0192</a>
              </li>
              <li className="flex gap-3 items-center">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-rose-400 text-sm"></i>
                </div>
                <a href="mailto:info@axispointmedical.com" className="text-zinc-400 text-sm hover:text-white cursor-pointer">info@axispointmedical.com</a>
              </li>
              <li className="flex gap-3 items-start">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-time-line text-rose-400 text-sm"></i>
                </div>
                <span className="text-zinc-400 text-sm leading-relaxed">Mon–Fri: 8am–6pm<br />Sat: 9am–2pm</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-zinc-600 text-xs">&copy; {new Date().getFullYear()} AxisPoint Medical. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="text-zinc-600 text-xs hover:text-zinc-400 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-zinc-600 text-xs hover:text-zinc-400 transition-colors cursor-pointer">Terms of Use</a>
            <a href="#" className="text-zinc-600 text-xs hover:text-zinc-400 transition-colors cursor-pointer">HIPAA Notice</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
